import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AttachmentModalData } from 'src/app/Attachment/attachment.modal.model';
import { CommentModalData } from 'src/app/Comments/comments.service';

export interface ICellRendererParamsForPaymentBatchPaymentsGridAction extends ICellRendererParams {
    canEdit: (params: ICellRendererParamsForPaymentBatchPaymentsGridAction) => boolean;
    edit: (params: ICellRendererParamsForPaymentBatchPaymentsGridAction) => void;
    delete: (params: ICellRendererParamsForPaymentBatchPaymentsGridAction) => void;
    canDelete: (params: ICellRendererParamsForPaymentBatchPaymentsGridAction) => boolean;
}

@Component({
    selector: 'payments-grid-action-cell',
    template: `
    @if (!params.data?.selectedTotalsRow) {
      @if (row && row.hasComments) {
        <span class="icon-indicator">
          <i class="fa fa-commenting fa-fw"></i>
        </span>
      }
      @if (row && !row.hasComments) {
        <span class="icon-indicator">
          <i class="fa fa-fw"></i>
        </span>
      }
      @if (row && row.hasAttachments) {
        <span class="icon-indicator">
          <i class="fa fa-files-o fa-fw"></i>
        </span>
      }
      @if (row) {
        <entity-comments
          [hasComments]="row && row.hasComments"
          buttonClass="ace-btn btn-primary has-icon grid-action-button"
          [modalData]="commentModalData"
          helpTooltip
          helpContentId="app.comments"
          position="bottom">
        </entity-comments>
      }
      @if (row) {
        <entity-attachments [hasAttachments]="row && row.hasAttachments"
          buttonClass="ace-btn btn-primary has-icon grid-action-button"
          [modalData]="attachmentModalData"
          helpTooltip
          helpContentId="app.attachments"
          position="bottom">
        </entity-attachments>
      }
      @if (row && params.canDelete(params)) {
        <button type="button"
          class="ace-btn has-icon btn-primary btn-danger grid-action-button"
          (click)="onDeleteClicked()"
          helpTooltip
          helpContentId="app.delete"
          position="bottom">
          <i class="fa fa-trash"></i>
        </button>
      }
    }
    `,
    standalone: false
})
export class PaymentBatchPaymentsGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForPaymentBatchPaymentsGridAction;
    row: Core.PaymentBatchDetailsEntryModel;
    attachmentModalData: AttachmentModalData;
    commentModalData: CommentModalData;

    agInit(params: ICellRendererParamsForPaymentBatchPaymentsGridAction): void {
        this.params = params;
        this.row = params.data as Core.PaymentBatchDetailsEntryModel;

        if (!this.row || params.data?.selectedTotalsRow) {
            return;
        }
        this.attachmentModalData = {
            entityType: 'Tax Bill',
            parentId: this.row.parcelId,
            parentType: 'Parcel',
            entityName: this.row.parcelAcctNum,
            entityDescription: `${this.row.taxYear} - ${this.row.collector} Bill`,
            year: this.row.taxYear,
            belowParcelEntity: {
                id: this.row.billId,
                typeId: Core.EntityTypes.Bill,
                name: 'Bill'
            },
            readOnly: !this.params.canEdit(params)
        } as AttachmentModalData;

        this.commentModalData = {
            entityID: this.row.billId,
            entityTypeID: Core.EntityTypes.Bill,
            disableCommentTypeSelection: true,
            parcelAcctNum: this.row.parcelAcctNum,
            canEdit: this.params.canEdit(params),
            parcelID: this.row.parcelId,
            description: `${this.row.taxYear} - ${this.row.collector} Bill`,
            year: this.row.taxYear.toString()
        } as CommentModalData;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }


    // descoped for now
    // onEditClicked(): void {
    //     this.params.edit(this.params);
    // }

    onDeleteClicked(): void {
        this.params.delete(this.params);
    }
}
